<section class="flex flex-col gap-4">
  <h3 class="text-hurrey-24 md:text-hurrey-28 lg:text-hurrey-36 text-purple_100 text-center"> Built for Every Kind of
    Educator</h3>

  <div class="grid grid-cols-12 gap-3">
    <div class="col-span-12 md:col-span-6 lg:col-span-4 flex flex-col gap-3 rounded-md medium_box_shadow">
      <figure class="h-[300px] flex items-center bg-sky_lightest">
        <img src="../../../../assets/images/schools.jpeg" alt="Schools" class="object-fill h-full w-full">
      </figure>
      <div class="p-2 px-4 flex flex-col gap-2">
        <h4 class="text-hurrey-20 md:text-hurrey-24 lg:text-hurrey-28 font-semibold">Schools</h4>
        <p class="text-hurrey-12 md:text-hurrey-16 lg:text-hurrey-20 text-ink_light">Streamline operations, improve
          learning outcomes</p>
      </div>

    </div>
    <div class="col-span-12 md:col-span-6 lg:col-span-4 flex flex-col gap-3 rounded-md medium_box_shadow">
      <figure class="h-[300px] flex items-center">
        <img src="../../../../assets/images/teachers.webp" alt="Teachers" class="object-fill h-full w-full">
      </figure>
      <div class="p-2 px-4 flex flex-col gap-2">
        <h4 class="text-hurrey-20 md:text-hurrey-24 lg:text-hurrey-28 font-semibold ">Teachers </h4>
        <p class="text-hurrey-12 md:text-hurrey-16 lg:text-hurrey-20 text-ink_light">Get real-time insights on every
          student along with individualized reports</p>
      </div>
    </div>


    <div class="col-span-12 md:col-span-6 lg:col-span-4 flex flex-col gap-3 rounded-md medium_box_shadow">
      <figure class="h-[300px] flex items-center">
        <img src="../../../../assets/images/tutions.jpeg" alt="Tutions" class="object-fill h-full w-full">
      </figure>
      <div class="p-2 px-4 flex flex-col gap-2">
        <h4 class="text-hurrey-20 md:text-hurrey-24 lg:text-hurrey-28 font-semibold">Tuition & Coaching
          Institutes</h4>
        <p class="text-hurrey-12 md:text-hurrey-16 lg:text-hurrey-20 text-ink_light">Deliver premium learning with minimal
          setup</p>
      </div>
    </div>

  </div>


</section>
